import { RoutePermissionTypes } from "@shared/src/enums/RoutePermissionTypes";
import { PhaseCardItemDto } from "../phase/PhaseCardItemDto";
import { RouteCardItemDto } from "./RouteCardItemDto";
import { PhaseDisplacementDto } from "../phase/PhaseDisplacementDto";
import { iRouteExpandCard } from "./iRouteExpandCard";
import { Incoterms } from "@shared/src/enums/Incoterms";
import { IconDto } from "../IconDto";
import { SelectItemDto } from "../base/select/SelectItemDto";
import { ContadorsDto } from "../phase/slot/ContadorsDto";
import { ActionsStripDto } from "../maintenance/action/ActionsStripDto";

export class RouteCardItemExpandDto extends RouteCardItemDto implements iRouteExpandCard {
    static build(value: ContadorsDto): RouteCardItemExpandDto {
        let r: RouteCardItemExpandDto = new RouteCardItemExpandDto();
        r.kilosCount = value.kilosCount;
        r.litresCount = value.litresCount;
        r.packetCount = value.packetCount;
        r.productCount = value.productCount;
        r.quantityProduct = value.quantityProduct;
        r.shipmentCount = value.shipmentCount;
        r.showKilosCountOnRouteCard = value.showKilosCountOnRouteCard;
        r.showLitresCountOnRouteCard = value.showLitresCountOnRouteCard;
        r.showPacketCountOnRouteCard = value.showPacketCountOnRouteCard;
        r.showPalletCountOnRouteCard = value.showPalletCountOnRouteCard;
        r.showProductCountOnRouteCard = value.showProductCountOnRouteCard;
        return r;
    }

    public readUuid: string;
    public writeUuid: string;

    public driverName: string;
    public driverLegalIdentification: string;
    public driverPhone: string;

    public carrierName: string;
    public showAskCarrierName: boolean;
    public carrierLegalIdentification: string;
    public showAskCarrierLegalIdentification: boolean;
    public carrierAddress: string;
    public showAskCarrierAddress: boolean;
    public hidePlateC: boolean;


    public carrierCode: string;
    public showAskCarrierCode: boolean;
    public showSelectorCarrierCode: boolean;
    public carrierCodes: Array<SelectItemDto>;

    public phases: PhaseCardItemDto[];
    public phasesDisplacement: PhaseDisplacementDto[];
    public actions: ActionsStripDto;

    public canGrouping: boolean;
    public canDivided: boolean;
    public canExwork: boolean;
    public canPhasesChangeDates: boolean;
	public canReorderShipmentInRoute: boolean;
	public canReorderPackageInRoute: boolean;
    public canChangeConditions: boolean;
    public canShowCMR: boolean;
    public canChangeBooking: boolean;
    public canTreeChart: boolean;
    public routePermission: RoutePermissionTypes;

    public routeParentGroupId: number;

    public canChangedManagementModel: boolean;
    public managementModel: string;
    public managementModelId: number;
    public typologyId: number;
    public incoterm: Incoterms;

    public additionalDriversPhones: string;

    public partnerDriverId: number;
    public partnerSecondDriverId: number;
    public partnerCarrierId: number;
    public partnerShipperId: number;
    public partnerLogisticOperatorId: number;
    public partnerInspectorId: number;
    public partnerHealthCertifierId: number;
    public partnerClientPreferentId: number;

    public icons: Array<IconDto>;

}
